import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { PaymentModeState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): PaymentModeState => state.paymentMode,
);

export default selectors;
